import { BaseService } from '../../../infra/base.service'
import type { MediaEntity } from './media.entity'
import type { MediasRepository } from './medias.repository'

export class MediasService extends BaseService<MediaEntity> {
    constructor(private rep: MediasRepository) {
        super(rep)
    }

    async getPublic(mediaId: string) {
        return await this.rep.getPublic(mediaId)
    }
}
